export const FILTER_CHANGED = 'filterChanged';

export enum TARGET_FILTERS_TYPES {
  COMPANY,
  ENDPOINT,
  OPERATING_SYSTEM,
  TAG
}
